import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import { get, filter } from 'lodash';
import classnames from 'classnames';
import AddOnsRows from '../AddOnsRows/add-ons-rows';
import AddOnsReviewTableRows from '../../../../../app-bookings-custom/add-ons-review-table-rows';
import Table from '../../../../../elements-tables/Table';
import { injectIntl, intlShape } from 'react-intl';

const AddOnsTable = ({
  ssoId,
  inventory,
  currency,
  toggleModal,
  openModal,
  onModalClose,
  getInventoryItem,
  items,
  viewAddOnDetailsAction,
  editAddOnAction,
  handleItemChange,
  isReviewPage = false,
  contract,
  masterContract,
  itemsArray,
  className,
  whichModal,
  iosWebView,
  guestView,
  hostAddOnsSummary,
  intl,
  addOnsSummaryLoading
}) => {
  const masterCalc = get(masterContract, 'calculations', {});
  const addOnsCalculations = get(masterCalc, 'add_ons', {});
  const addOnsTotal = get(addOnsCalculations, 'amount', 0);
  const hasConciergeItems = get(masterCalc, 'concierge_add_ons_summary');

  const addOnsTaxTotal = !guestView && hasConciergeItems
    ? get(masterCalc, 'host_add_ons_summary.taxes', 0)
    : get(addOnsCalculations, 'taxes', 0);

  const addOnsFeeTotal = !guestView && hasConciergeItems
    ? get(masterCalc, 'host_add_ons_summary.fees', 0)
    : get(addOnsCalculations, 'fees', 0);

  const taxesAndFees = get(addOnsCalculations, 'taxes_and_fees', 0);
  const taxesAndFeesArray = get(masterCalc, 'add_on_taxes_and_fees', []);
  const taxesArray = filter(taxesAndFeesArray, (tax) => {
    if (!guestView) {
      return 'tax' === tax.type && !tax.is_concierge;
    }

    return 'tax' === tax.type;
  }, []);

  const feesArray = filter(taxesAndFeesArray, (fee) => {
    if (!guestView) {
      return 'fee' === fee.type && !fee.is_concierge;
    }

    return 'fee' === fee.type;
  }, []);

  const tableHeaders = [
    { label: isReviewPage
      ? intl.formatMessage({ id: 'inbox.add_ons_table.addons', defaultMessage: 'Add-ons' })
      : intl.formatMessage({ id: 'inbox.add_ons_table.title', defaultMessage: 'Title' }),
    classname: 'title' },
    { label: intl.formatMessage({ id: 'inbox.add_ons_table.quantity', defaultMessage: 'Quantity' }), classname: 'quantity d-xs-none d-sm-block' },
    { label: intl.formatMessage({ id: 'inbox.add_ons_table.price', defaultMessage: 'Price' }), classname: 'price d-xs-none d-sm-block' },
    { label: intl.formatMessage({ id: 'inbox.add_ons_table.amount', defaultMessage: 'Amount' }), classname: 'amount d-xs-none d-sm-block' }
  ];

  return (
    <div className={classnames('add-ons-section margin-lg-bottom', className, { 'review-page': isReviewPage })}>
      <div className={classnames('add-ons-table', { 'add-ons-review-table': isReviewPage })}>
        <Table
          tableHeaders={tableHeaders}
          tableBody={
            isReviewPage ?
              <AddOnsReviewTableRows
                itemsArray={itemsArray}
                currency={currency}
                ssoId={ssoId}
                addOnsTotal={addOnsTotal}
                hostAddOnsSummary={hostAddOnsSummary}
                addOnsTaxTotal={Number(addOnsTaxTotal).toFixed(2)}
                addOnsFeeTotal={Number(addOnsFeeTotal).toFixed(2)}
                taxesArray={taxesArray}
                feesArray={feesArray}
                toggleModal={toggleModal}
                whichModal={whichModal}
                guestView={guestView}
                iosWebView={iosWebView}
                masterContract={masterContract}
              />
              :
              <FieldArray
                name="addOns"
                inventory={inventory}
                currency={currency}
                component={AddOnsRows}
                masterContract={masterContract}
                toggleModal={toggleModal}
                onModalClose={onModalClose}
                openModal={openModal}
                getInventoryItem={getInventoryItem}
                items={items}
                viewAddOnDetailsAction={viewAddOnDetailsAction}
                editAddOnAction={editAddOnAction}
                handleItemChange={handleItemChange}
                contract={contract}
                ssoId={ssoId}
                addOnsTotal={addOnsTotal}
                hostAddOnsSummary={hostAddOnsSummary}
                addOnsTaxTotal={addOnsTaxTotal}
                addOnsFeeTotal={addOnsFeeTotal}
                taxesAndFees={taxesAndFees}
                taxesArray={taxesArray}
                feesArray={feesArray}
                hasConciergeItems={hasConciergeItems}
                addOnsSummaryLoading={addOnsSummaryLoading}
              />
          }
        />
      </div>
    </div>
  );
};

AddOnsTable.propTypes = {
  inventory: PropTypes.object,
  currency: PropTypes.string,
  toggleModal: PropTypes.func,
  items: PropTypes.array,
  openModal: PropTypes.func,
  onModalClose: PropTypes.func,
  handleItemChange: PropTypes.func,
  viewAddOnDetailsAction: PropTypes.func,
  getInventoryItem: PropTypes.func,
  editAddOnAction: PropTypes.func,
  isReviewPage: PropTypes.bool,
  contract: PropTypes.object,
  masterContract: PropTypes.object,
  itemsArray: PropTypes.array,
  whichModal: PropTypes.string,
  ssoId: PropTypes.string,
  guestView: PropTypes.bool,
  className: PropTypes.string,
  iosWebView: PropTypes.bool,
  addOnsSummaryLoading: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(AddOnsTable);
